import { useEffect } from "react";

const SCROLLBAR_CSS =
  "[data-testid^=player-] [style*='overflow: auto']::-webkit-scrollbar{width:5px}" +
  "[data-testid^=player-] [style*='overflow: auto']::-webkit-scrollbar-track{background:transparent}" +
  "[data-testid^=player-] [style*='overflow: auto']::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.16);border-radius:3px}" +
  "[data-testid^=player-] [style*='overflow: auto']::-webkit-scrollbar-thumb:hover{background:rgba(255,255,255,0.28)}" +
  "[data-testid^=player-] [style*='overflow: auto']{scrollbar-width:thin;scrollbar-color:rgba(255,255,255,0.16) transparent}";

let scrollbarStyleInjected = false;

export function usePlayerMenuScrollbar(): void {
  useEffect(() => {
    if (scrollbarStyleInjected) return;
    scrollbarStyleInjected = true;
    const style = document.createElement("style");
    style.id = "jellyflix-player-scrollbar";
    style.textContent = SCROLLBAR_CSS;
    document.head.appendChild(style);
  }, []);
}
